"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.PaymentGatewayCreateDto = void 0;
var class_validator_1 = require("class-validator");
var class_transformer_1 = require("class-transformer");
var api_credential_type_dto_1 = require("./api-credential-type.dto");
var constants_1 = require("../constants");
var payment_gateway_installment_dto_1 = require("./payment-gateway-installment.dto");
var payment_gateway_multi_installment_dto_1 = require("./payment-gateway-multi-installment.dto");
var PaymentGatewayCreateDto = (function () {
    function PaymentGatewayCreateDto() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], PaymentGatewayCreateDto.prototype, "isActive");
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsNotEmpty(),
        __metadata("design:type", String)
    ], PaymentGatewayCreateDto.prototype, "name");
    __decorate([
        class_validator_1.IsNotEmpty(),
        class_validator_1.IsIn(Object.keys(constants_1.PAYMENT_GATEWAYS)),
        __metadata("design:type", String)
    ], PaymentGatewayCreateDto.prototype, "template");
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return api_credential_type_dto_1.ApiCredential; }),
        __metadata("design:type", api_credential_type_dto_1.ApiCredential)
    ], PaymentGatewayCreateDto.prototype, "apiCredentials");
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], PaymentGatewayCreateDto.prototype, "paymentOptionGroup");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsArray(),
        class_transformer_1.Type(function () { return payment_gateway_installment_dto_1.PaymentGatewayInstallmentDto; }),
        class_validator_1.ValidateNested({ each: true }),
        __metadata("design:type", Array)
    ], PaymentGatewayCreateDto.prototype, "installments");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsArray(),
        class_transformer_1.Type(function () { return payment_gateway_multi_installment_dto_1.PaymentGatewayMultiInstallmentDto; }),
        class_validator_1.ValidateNested({ each: true }),
        __metadata("design:type", Array)
    ], PaymentGatewayCreateDto.prototype, "multiInstallments");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsArray(),
        class_transformer_1.Type(function () { return String; }),
        __metadata("design:type", Array)
    ], PaymentGatewayCreateDto.prototype, "autoSelectMap");
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], PaymentGatewayCreateDto.prototype, "company");
    return PaymentGatewayCreateDto;
}());
exports.PaymentGatewayCreateDto = PaymentGatewayCreateDto;
//# sourceMappingURL=payment-gateway-create.dto.js.map